/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { map } from 'rxjs/operators';
import dayjs from 'dayjs';

@Injectable({
  providedIn: 'root'
})

export class ReportService {
  reportsBaseUrl = `${this.dataCollectorService.baseUrl}/reports-service`;
  reportsUrl = `${this.dataCollectorService.baseUrl}/v3/reports/`;
  reportApiUrls: any = {
    folderUrl: `${this.reportsBaseUrl}/v3/folders`,
    reportSourcesUrl: `${this.reportsBaseUrl}/v3/sources`,
    createReportUrl: `${this.reportsBaseUrl}/v3/reports`,
    attributeUrl: `${this.reportsBaseUrl}/v3/attributes`,
  };
   reportSource = new Subject<any>();
   storedFolders = new BehaviorSubject<any>('');
   storedSourcesData = new BehaviorSubject<any>('');
  constructor(private dataCollectorService: DataCollectorService) { }
  createFolder(payload): any{
    return this.dataCollectorService.postData(this.reportApiUrls?.folderUrl,payload);
  }
  updateFolder(payload,folderUid): any{
    return this.dataCollectorService.putData(`${this.reportApiUrls?.folderUrl}/${folderUid}`,payload);
  }
  deleteFolder(folderUid): any{
    return this.dataCollectorService.deleteData(`${this.reportApiUrls?.folderUrl}/${folderUid}`);
  }
  getFolderDetails(payload): any{
    return this.dataCollectorService.getData(`${this.reportApiUrls?.folderUrl}/${payload}`);
  }
  getFolderDetailsUrl(folderUid: string): string{
    return this.reportApiUrls?.folderUrl + `/${folderUid}`;
}
  getReports(): any {
    return this.reportsBaseUrl + '/v3/reports';
  }
  getFolderListingUrl(): string {
    return this.reportApiUrls?.folderUrl;
  }
  get storedFolders$(): any {
    return this.storedFolders.asObservable();
  }
  getFolders(): any {
    const storedFolders = sessionStorage.getItem('report_folders');
    if (storedFolders) {
      this.storedFolders.next(JSON.parse(storedFolders));
    } else {
        this.dataCollectorService.getData(this.getFolderListingUrl()).subscribe(
          (response: any) => {
            sessionStorage.setItem('report_folders',JSON.stringify(response));
            const parsedData = JSON.parse(sessionStorage.getItem('report_folders'));
            this.storedFolders.next(parsedData);
          },
        );
    }
  }
  updateFavoriteReports(): any {
    return `${this.reportsBaseUrl}/v3/favorite`;
  }
  deleteFavoriteReports(): any {
    return `${this.reportsBaseUrl}/v3/favorite`;
  }
  getReportSources(): void {
    return this.reportApiUrls.reportSourcesUrl;
  }
  getSources(): Promise<any> {
    return new Promise((resolve, reject) => {
      const storedSources = sessionStorage.getItem('report_sources');
      if (storedSources) {
        this.storedSourcesData.next(JSON.parse(storedSources));
        resolve(JSON.parse(storedSources));
      } else {
        this.dataCollectorService.getData(this.getReportSources()).subscribe(
          (response: any) => {
            sessionStorage.setItem('report_sources', JSON.stringify(response));
            this.storedSourcesData.next(response);
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
      }
    });
  }
  getReportSource(): Observable<any>{
    return this.dataCollectorService.getData(this.reportApiUrls.reportSourcesUrl);
  }

  createReport(payload): Observable<any>{
    return this.dataCollectorService.postData(this.reportApiUrls.createReportUrl, payload);
  }
  getAllReports(payload): Observable<any>{
    return this.dataCollectorService.getData(this.reportsBaseUrl + '/v3/reports',payload);
  }
  deleteReport(payload): Observable<any>{
    return this.dataCollectorService.deleteData(this.reportsBaseUrl + '/v3/reports/' + payload);
  }
  getStarredReports(payload): Observable<any>{
    return this.dataCollectorService.getData(this.reportsBaseUrl + '/v3/favorite',payload);
  }
  getMyReports(payload): Observable<any>{
    return this.dataCollectorService.getData(this.reportsBaseUrl + '/v3/reports/me',payload);
  }
  getScheduledReports(payload): Observable<any>{
    return this.dataCollectorService.getData(this.reportsBaseUrl + '/v3/schedule',payload);
  }
  createSchedule(payLoad): Observable<any>{
    return this.dataCollectorService.postData(`${this.reportsBaseUrl}/v3/schedule`,payLoad);
  }
  updateSchedule(scheduleUid,payLoad): Observable<any>{
    return this.dataCollectorService.putData(`${this.reportsBaseUrl}/v3/schedule/${scheduleUid}`,payLoad);
  }
  deleteScheduledReports(payload): Observable<any>{
    return this.dataCollectorService.deleteData(this.reportsBaseUrl + '/v3/schedule/'+ payload);
  }
  getScheduledReportDetails(scheduleUid): Observable<any>{
    return this.dataCollectorService.getData(`${this.reportsBaseUrl}/v3/schedule/${scheduleUid}`);
  }
  deleteExecutionReport(payload): Observable<any>{
    return this.dataCollectorService.deleteData(this.reportsBaseUrl + '/v3/executions/'+ payload);

  }
  getReportHistory(payload): Observable<any>{
    return this.dataCollectorService.getData(this.reportsBaseUrl + '/v3/executions',payload);
  }
  updateReportExecution(payload): Observable<any>{
    return this.dataCollectorService.postData(this.reportsBaseUrl + '/v3/executions',payload);
  }
  getReportExecutionStatus(execution_uid): Observable<any>{
    return this.dataCollectorService.getData(`${this.reportsBaseUrl}/v3/executions/${execution_uid}/status`);
  }
  getReportPreviewData(execution_uid): Observable<any>{
    return this.dataCollectorService.getData(`${this.reportsBaseUrl}/v3/executions/${execution_uid}/data`);
  }
  getMyAllReports(): Observable<any>{
    return this.dataCollectorService.getData(this.reportsBaseUrl + '/v3/reports/me');
  }
  getSharedReports(payload): Observable<any>{
    return this.dataCollectorService.getData(this.reportsBaseUrl + '/v3/reports/shared',payload);
  }
  getTemplates(payload): Observable<any>{
    return this.dataCollectorService.getData(this.reportsBaseUrl + '/v3/template',payload);
  }
  getTemplateDetails(templateUid): Observable<any>{
    return this.dataCollectorService.getData(this.reportsBaseUrl + '/v3/template/'+templateUid);
  }
  getRecentReports(): Observable<any>{
    return this.dataCollectorService.getData(this.reportsBaseUrl + '/v3/reports/recent');
  }
  moveFolder(sourceFolder,destinatinationFolder,reportUid): Observable<any>{
    const payload={
      'folder_uid': destinatinationFolder ? destinatinationFolder : '',
      'report_uid': reportUid
    };
    return this.dataCollectorService.postData(`${this.reportApiUrls.folderUrl}/${sourceFolder}/move`,payload);
  }
  revokeAccess(payload): Observable<any>{
    return this.dataCollectorService.postReportData(`${this.reportsBaseUrl}/v3/shared/revoke`,payload);

  }
  addReportsToFolder(folderUid,reportUid): Observable<any>{
    const payload = {
      'report_uid': [reportUid]
     };
    return this.dataCollectorService.postData(`${this.reportApiUrls.folderUrl}/${folderUid}/reports`,payload);
  }

  updateReport(payload, reportUid): Observable<any>{
    const updateUrl = `${this.reportsBaseUrl}/v3/reports/${reportUid}`;
    return this.dataCollectorService.putData(updateUrl, payload);
  }
  getShareAccess(reportUid): Observable<any>{
    const payload = {
      'report_uid':reportUid
    };
    const url = `${this.reportsBaseUrl}/v3/shared/users/`;
    return this.dataCollectorService.getData(url,payload);
  }
  postShareAccess(payload,notifyUsers): Observable<any>{
    const url = `${this.reportsBaseUrl}/v3/shared/?notify_users=${notifyUsers}`;
    return this.dataCollectorService.postData(url,payload);
  }
  updateShareAccess(payload): Observable<any>{
    const url = `${this.reportsBaseUrl}/v3/shared/`;
    return this.dataCollectorService.putData(url,payload);
  }
  getReportDetails(reportUid): Observable<any>{
    const url = `${this.reportsBaseUrl}/v3/reports/${reportUid}`;
    return this.dataCollectorService.getData(url);
  }

  getModuleAttribute(urlParams): Observable<any>{
    return this.dataCollectorService.getData(this.reportApiUrls.attributeUrl, urlParams);
  }
  updateReportStatus(payload,scheduleUid): Observable<any>{
    return this.dataCollectorService.putData(`${this.reportsBaseUrl}/v3/schedule/${scheduleUid}/activate`,payload);
  }
  downloadReport(executionUid): Observable<any>{
    return this.dataCollectorService.getData(`${this.reportsBaseUrl}/v3/executions/download/${executionUid}`,{ responseType: 'text' });
}
downloadReportUrl(executionUid): string{
  return `${this.reportsBaseUrl}/v3/executions/download/${executionUid}`;
}
getAllUsers(payload): any{
  const userURL = `${this.dataCollectorService.baseUrl}/user/filter`;
  return this.dataCollectorService.getData(userURL,payload);
}
getUsers(filter: string): Observable<any> {
  const payload = {
    'filter.keyword': filter
  };
  const userURL = `${this.dataCollectorService.baseUrl}/users`;
  return this.dataCollectorService.getData(userURL,payload);
}
getAllUser(payload): Observable<any>{
  const userURL = `${this.dataCollectorService.baseUrl}/user/all`;
  return this.dataCollectorService.getData(userURL,payload);
}
getAllUserUrl(): any{
  const userURL = `${this.dataCollectorService.baseUrl}/users/filter`;
  return userURL;
}

  getDetailedReportPreview(reportUid: string, payload: any): Observable<any>{
    const previewUrl = `${this.reportsBaseUrl}/v3/reports/${reportUid}/preview`;
    return this.dataCollectorService.postData(previewUrl, payload);
  }

  getSummaryReportPreview(reportUid: string, payload: any): Observable<any>{
    const previewUrl = `${this.reportsBaseUrl}/v3/reports/${reportUid}/summery/preview`;
    return this.dataCollectorService.postData(previewUrl, payload);
  }

  getModuleMetaFilters(module): any{
    const metaFilterUrl = `${this.reportsBaseUrl}/v3/meta/filter?module=${module}`;
    return this.dataCollectorService.getData(metaFilterUrl);
  }

  buildReportFromTemplate(template: any): Observable<any> {
    const payload = {
      'report_name': `${template?.template_name}-${dayjs().format('DD-MMMM-YYYY-HH-mm-ss')}`,
      'primary_module': template?.primary_module?.module_key,
      'report_source': template?.report_source,
      'report_columns': template?.report_columns,
      'report_type': template?.report_type,
      'template_uid': template?.template_uid
    };
    return this.createReport(payload);
  }

}

